import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class SamlIcon extends BaseIcon {
  getChildren = () => [
    <rect fill="none" stroke="#2e3f58" strokeMiterlimit={10} x=".5" y="6.5" width="31" height="19" rx="2"/>,
    <path fill="none" stroke="#2e3f58" strokeMiterlimit={10} className="cls-1" d="M14.5 6.5v19"/>,
    <path fill="none" stroke="#2e3f58" strokeLinecap="round" strokeLinejoin="round" d="M17 13.5h10.5M17 17.5h7"/>,
    <path id="Path_18934" data-name="Path 18934"
          d="M4 20.57c-.28.14-.69.29-1 .43h9a7 7 0 00-1-.43c-1.63-.57-2.18-1.14-2.18-2.28 0-.72.55-.43.69-1.72.14-.57.55 0 .69-1.28a.64.64 0 00-.28-.58 7.83 7.83 0 00.14-1.28c.28-.57-.28-2.43-2.49-2.43a2.54 2.54 0 00-2.77 2.43 6.12 6.12 0 00.14 1.28.9.9 0 00-.14.58c.14 1.28.55.71.69 1.28.28 1.29.69 1 .69 1.72 0 1.14-.55 1.71-2.18 2.28z"
          fill={ this.getColor() }/>
  ]
  getViewBox = () => '0 0 32 32'
}
